/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCargoSeparateItem } from './order_cargo_separate_item'
import type { OrderCargoSize } from './order_cargo_size'
import type { OrderCargoSummary } from './order_cargo_summary'
import type { OrderCargoTotal } from './order_cargo_total'
/**
 * Информация о грузе
 */
export type OrderCargoInfo = {
  /**
   * Способ указания информации о грузе
   */
  type: OrderCargoInfo.type
  /**
   * Общая информация по грузу
   */
  summary: OrderCargoSummary
  /**
   * Информация по грузоместам (обязательное поле при type=Separate)
   */
  separate?: Array<OrderCargoSeparateItem>
  /**
   * Информация о грузе в виде общего веса и объема (обязательное поле при type=Total)
   */
  total?: OrderCargoTotal
  /**
   * Информация о грузе в виде общего веса и объема (обязательное поле при type=Total)
   */
  size?: OrderCargoSize
}
export namespace OrderCargoInfo {
  /**
   * Способ указания информации о грузе
   */
  export enum type {
    SEPARATE = 'separate',
    TOTAL = 'total',
    SIZE = 'size'
  }
}
